module.exports = __webpack_public_path__ + "static/media/AIAJ 18-1_Final Cover_001.53bcb0bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/AIAJ 18-1_Final Cover_001.jpg
// module id = 1294
// module chunks = 1